import { Component } from 'preact';
import ListEnhancedContent from '../../util/listEnhancedContent'
import axios from 'axios';
import Loader from '../../util/loader'
require('es6-promise').polyfill();

export default class SelectedItemEC extends Component {

  constructor() {
		super();
		// set initial time:
		this.state = { selectedItemECData: 'loading' };
	}

  componentWillMount(){

      let richContentPromiseArray = []


      axios.get('https://columbus-c4de8.firebaseio.com/products/' + this.props.selectedItemId + '/content/compareTable/richContentList.json').then( (response) => {

      let selectedItemECList = response.data

      if (!selectedItemECList){
        this.setState({selectedItemECData: []})
        return
      }

      selectedItemECList.map( currentRichItem =>
          richContentPromiseArray.push( axios.get('https://columbus-c4de8.firebaseio.com/richContent/' + currentRichItem.richId + '.json') )
        )

      return Promise.all(richContentPromiseArray)

    }).then( (results)=> {

        let selectedItemECData = []

        results.map( current => {
          selectedItemECData.push ( current.data)
        })

        this.setState({selectedItemECData, errorMessage: null})

    }).catch (err => {
      console.error(err.message)
    })
  }

  render(){

    if (this.state.selectedItemECData === 'loading'){
      return (
        <div  className='col-xs-12'>
					<Loader />
				</div>
      );
    } else if (this.state.errorMessage){
			return null
		}

		return (
			<div className='col-xs-12' >
        <ListEnhancedContent currentItemECData={this.state.selectedItemECData} />
			</div>
		);
  }

}



// WEBPACK FOOTER //
// ./components/contentTypes/compareTable/selectedItemEC.js